import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
// import { getApi } from '../../api/endpoints';
import MultiSelectField from '../../components/form/MultiSelectField';

const FiltersPartial = (props) => {
  const { filtersModel, setFiltersModel } = props;

  const onUploaderTypeAdded = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, uploader_type: [...(prevState.uploader_type || []), selectedOption.id] }
    })
  }

  const onUploaderTypeRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, uploader_type: prevState.uploader_type.filter((id) => id !== removedOption.id) }
    })
  }

  const onStatusAdded = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, status: [...(prevState.status || []), selectedOption.id] }
    })
  }

  const onStatusRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, status: prevState.status.filter((id) => id !== removedOption.id) }
    })
  }

  return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
    <div>
      <Form.Group className="mb-3">
        <Form.Label>Uploader Type</Form.Label>
        <MultiSelectField
          options={[
            {
              id: 'sap_upload',
              name: 'Sap Upload'
            },
            {
              id: 'electricity_billings',
              name: 'Electricity Billings'
            },
            {
              id: 'tally_transactions',
              name: 'Tally Transactions'
            },
            {
              id: 'battery',
              name: 'Battery'
            },
            {
              id: 'rfid',
              name: 'Rfid'
            },
            {
              id: 'charging_station',
              name: 'Charging_station'
            },
            {
              id: 'ware_house',
              name: 'Ware House'
            },
            {
              id: 'inventory_items',
              name: 'Inventory Items'
            },
            {
              id: 'fleet_owner_customers',
              name: 'Fleet Owner Customers'
            },
            {
              id: 'states',
              name: 'States'
            },
            {
              id: 'location_coordinates',
              name: 'Location Coordinates'
            },
          ]}
          fieldName="uploader_type"
          stateModel={filtersModel}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onUploaderTypeAdded}
          onRemove={onUploaderTypeRemove}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Status</Form.Label>
        <MultiSelectField
          options={[
            {
              id: 'Uploaded',
              name: 'uploaded'
            },
            {
              id: 'Processing',
              name: 'processing'
            },
            {
              id: 'Success',
              name: 'success'
            },
            {
              id: 'Failed',
              name: 'failed'
            }
          ]}
          fieldName="status"
          stateModel={filtersModel}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onStatusAdded}
          onRemove={onStatusRemove}
        />
      </Form.Group>
    </div>
  </Filters>
};

export default FiltersPartial;

